<div class="scenario-panel" *ngIf="!productCatalog">
  <div class="header">
    <h2 class="title">{{ data.plannerScenarioId !== undefined && data.plannerScenarioId !== null ? data.name : 'Unsere Empfehlung' }}</h2>
  </div>
  <div class="body">
    <section class="lamp-recommendation">
      <div class="description-section">
        <p class="description">{{ 'module.energyMap.scenarioPanel.descriptionText' | translate }}</p>
        <div class="legend" [class.-selected]="isLegendShown" (click)="isLegendShown = !isLegendShown">
          <a class="fa fa-question-circle legend-icon"></a>
        </div>

        <div class="legend-panel" *ngIf="isLegendShown">
          <h4 class="header">{{ 'module.energyMap.scenarioPanel.legendHeaderText' | translate }}</h4>
          <div class="legend -recommended">{{ 'module.energyMap.scenarioPanel.legendRecommendedHeader' | translate }}</div>
          <div class="legend -manual">{{ 'module.energyMap.scenarioPanel.legendManualHeader' | translate }}</div>
        </div>
      </div>

      <app-expansion-panel *ngFor="let group of data.lampGroup; trackBy: trackByFn" class="app-expansion-panel" [expanded]="group.expanded">
        <div class="lamp-replacement" expansion-header>
          <div class="count">
            {{ group.lampsCount | number: '' : 'es' }}
          </div>
          <div class="title">
            <h3 class="category">{{ group.lightType }}</h3>
            <h4 class="type">{{ group.typesCount }}</h4>
          </div>
          <div class="controls">
            <a
              class="fa fa-eye"
              [class.-selected]="group.isHighlighted"
              (click)="toggleHighlightGroup(group)"
              matTooltip="Hervorheben"
              tooltipClass="kp2-custom-tooltip"
              matTooltipPosition="above"
            >
            </a>
            <a
              class="fa fa-retweet"
              (click)="showProductCatalogByLampType(group)"
              matTooltip="Alternativen"
              tooltipClass="kp2-custom-tooltip"
              matTooltipPosition="left"
            ></a>
            <a class="fa fa-trash-o" (click)="removeByCategory(group)" matTooltip="Löschen" tooltipClass="kp2-custom-tooltip" matTooltipPosition="left"></a>
          </div>
        </div>

        <div class="content" expansion-content *ngIf="group.lamps.length > 0">
          <hr class="divider" />
          <div class="group-names">
            <span class="label -duration">{{ 'module.energyMap.scenarioPanel.durationText' | translate }}</span>
            <span class="label -selection">{{ 'module.energyMap.scenarioPanel.selectionText' | translate }}</span>
          </div>
          <div class="lamp-planner-bar" *ngFor="let lampGroup of group.lamps; trackBy: trackByFn2">
            <app-expansion-conversion-bar
              class="app-conversion-bar"
              [lampGroup]="lampGroup"
              [isSameManufacturer]="data.isSameManufacturer"
              [isManual]="checkIfManual(lampGroup)"
              [lampGroupNewModelName]="formatSuggestNewLampModel(lampGroup.suggestedModel)"
              [recommendationType]="data.recommendationType"
              (modelRemoved)="removeLampGroup(group.lamps, lampGroup)"
              (showProductCatalogByModel)="showProductCatalogByModel($event)"
              (isHighlightChange)="onConversionHighlightChange(group, group.lamps)"
              (showProductDetailByModel)="showProductDetailByModel($event)"
            ></app-expansion-conversion-bar>
          </div>
        </div>
      </app-expansion-panel>
    </section>
    <section class="data-section">
      <span class="data">
        <span class="label">{{ 'module.energyMap.scenarioPanel.annualEnergySavingText' | translate }}</span>
        <span class="value">ca. {{ energySavings | number: '1.0-0' : 'es' }}{{ 'module.energyMap.scenarioPanel.annualEnergySavingUnitText' | translate }}</span>
      </span>

      <span class="data">
        <span class="label">{{ 'module.energyMap.scenarioPanel.annualCostSavingText' | translate }}</span>
        <span class="value">ca. {{ costSavings | number: '1.0-0' : 'es' }}{{ 'module.energyMap.scenarioPanel.annualCostSavingUnitText' | translate }}</span>
      </span>

      <span class="data">
        <span class="label">{{ 'module.energyMap.scenarioPanel.annualCO2SavingText' | translate }}</span>
        <span class="value">ca. {{ cO2Savings | number: '1.0-1' : 'es' }}{{ 'module.energyMap.scenarioPanel.annualCO2SavingUnitText' | translate }}</span>
      </span>

      <span class="data" [class.-secondary]="isKam">
        <span class="label">{{ 'module.energyMap.scenarioPanel.priceIndicationText' | translate }}</span>
        <span class="value">ca. {{ uvpCost | number: '1.0-0' : 'es' }}{{ 'module.energyMap.scenarioPanel.priceIndicationUnitText' | translate }}</span>
      </span>

      <span class="data" *ngIf="isKam">
        <span class="label emphasize">{{ 'module.energyMap.scenarioPanel.vatText' | translate }}</span>
        <span class="value emphasize">ca. {{ salesCost | number: '1.0-0' : 'es' }}{{ 'module.energyMap.scenarioPanel.vatUnitText' | translate }}</span>
      </span>
    </section>

    <button class="btn btn-primary efficiency-button" (click)="toggleStreetlightEfficiencyDialog()" *ngIf="!!authService.permissions.STREETLIGHT_EFFICIENCY">
      <span class="fa fa-sliders"></span> {{ 'module.energyMap.scenarioPanel.calculateEnergyEfficiencyText' | translate }}
    </button>

    <p class="reminder">
      {{ 'module.energyMap.scenarioPanel.reminder1Text' | translate }}
    </p>

    <p class="reminder">
      {{ 'module.energyMap.scenarioPanel.reminder2Text' | translate }}
    </p>

    <app-expansion-panel class="annahmen">
      <div class="label emphasize" expansion-header>{{ 'module.energyMap.scenarioPanel.assumptionText' | translate }}</div>
      <div expansion-content>
        <div class="reminder">{{ 'module.energyMap.scenarioPanel.assumptionReminder1Text' | translate }}</div>
        <div class="reminder">
          {{ 'module.energyMap.scenarioPanel.assumptionReminder2Text' | translate }}{{ grossElectricityCostString
          }}{{ 'module.energyMap.scenarioPanel.assumptionReminder2UnitText' | translate
          }}<span *ngIf="!!authService.permissions.MUNICIPALITY_ELECTRICITY_COST || !!authService.permissions.MUNICIPALITY_ELECTRICITY_COST_UPDATE"
            >(<a href="#" (click)="openLocalSettings($event); (false)">{{ 'module.energyMap.scenarioPanel.assumptionReminder2LinkText' | translate }}</a
            >)</span
          >.
        </div>
        <div class="reminder">{{ 'module.energyMap.scenarioPanel.assumptionReminder3Text' | translate: { co2Emission: co2Emission } }}</div>
        <div class="reminder">{{ 'module.energyMap.scenarioPanel.assumptionReminder4Text' | translate }}</div>
      </div>
    </app-expansion-panel>
  </div>

  <div class="footer">
    <button class="btn btn-outline-primary" (click)="showEmailModal()" *ngIf="!!authService.permissions.STREETLIGHT_PLANNER_SEND">
      <span class="fa fa-envelope"></span>Senden
    </button>
    <button
      *ngIf="!!authService.permissions.STREETLIGHT_PLANNER"
      class="btn btn-outline-primary"
      [disabled]="hasNoReplacement() || lampsCount === 0"
      (click)="showSaveModal()"
    >
      <span class="fa fa-check-circle"></span> {{ 'module.energyMap.scenarioPanel.saveScenarioText' | translate }}
    </button>
  </div>
  <button class="btn btn-primary btn-close" (click)="scenarioPanelClose()">
    <img class="x-icon" alt="close-icon" src="../../../../assets/icons/close-icon-white.svg" />
  </button>
</div>
<app-product-catalog
  *ngIf="productCatalog"
  [selectedLampIds]="selectedLampIds"
  [scenarioType]="data.recommendationTypeId"
  (selectLamp)="productSelected($event)"
  (showCatalog)="closeProductCatalog($event)"
></app-product-catalog>
<app-product-detail
  *ngIf="productDetail"
  [lamps]="lamp"
  (showDetail)="closeDetail($event)"
  (showProductCatalog)="closeProductCatalog($event)"
  (setLampType)="setLampType($event)"
></app-product-detail>
